const MAX_ITEMS_TO_SHOW = 6;
export { MAX_ITEMS_TO_SHOW };
